module.exports = __webpack_public_path__ + "img/crusher.948331f2.png";